import React, { useState, useEffect } from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { EMPTY_OBJECT } from './AddTaskList'

function ImportSegmentation(props) {
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [sqLDbList, setSqLDbList] = useState([])
    const [databaseId, setDatabaseId] = useState(-1)
    const [dataSourceSystemName, setDataSourceSystemName] = useState('')
    const [databaseName, setDatabaseName] = useState('')
    const [dataSources, setDataSources] = useState([])
    const [dimensions, setDimensions] = useState([])
    const [selectedDimension, setSelectedDimension] = useState('')
    const [jobFiles, setJobFiles] = useState([])
    const [selectedJobFileId, setSelectedJobFileId] = useState('')
    const [selectedJobFile, setSelectedJobFile] = useState('')
    const [filesWithinZip, setFilesWithinZip] = useState([])
    const [selectedFileWithinZip, setSelectedFileWithinZip] = useState('')
    const [columnsReadFromFile, setColumnsReadFromFile] = useState([])
    const [selectedSourceColumn, setSelectedSourceColumn] = useState('')
    const [selectedTargetColumn, setSelectedTargetColumn] = useState('')
    const [existingMembers, setExistingMembers] = useState(false)
    const [dimensionSegmentation, setDimensionSegmentation] = useState([])
    const [selectedSegments, setSelectedSegments] = useState([])

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setIsLoadingRequest(true)

            let getDataSources = props.getDataSources(props.taskData.databaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setDataSources(json)
                setDataSourceSystemName(props.taskData.dataSourceSystemName)
                setDimensions([])
                
                let getDimensions = props.getDimensions(props.taskData.databaseId, props.taskData.dataSourceSystemName)
                getDimensions.then((resp) => { 
                    if (resp.status !== 200) {
                        throw new Error(resp)
                    } else {
                        return resp.json()
                    }
                }).then((json) => {
                    setIsLoadingRequest(false)

                    let processedResponse = []
                    let processedSegments = []
                    for (let x = 0; x < json.length; x++) {
                        if (json[x]["typeOfDimension"] !== -1) {
                            processedResponse.push(json[x])
                        }
                        for (let y = 0; y < json[x]["segments"].length; y++) {
                            processedSegments.push({ "dimension": json[x]["systemName"], "alias": json[x]["segments"][y]["alias"] })
                        }
                    }

                    setDimensions(processedResponse)
                    setDimensionSegmentation(processedSegments)
                    setSelectedDimension(props.taskData.selectedDimensionSystemName)
                    setSelectedSegments(props.taskData.sourceFiles)
                }).catch((ex) => {
                    console.error(ex)
                    setDataSources([])
                    setDimensions([])
                    setSelectedDimension('')
                    setIsLoadingRequest(false)
                })
            }).catch((ex) => {
                console.error(ex)
                setDataSourceSystemName('')
                setDataSources([])
                setDatabaseName('')
                setDimensions([])
                setDimensionSegmentation([])
                setDatabaseName('')
                setSelectedDimension('')
                setIsLoadingRequest(false)
                setSearchTerm('')
            })

            setDatabaseName(props.taskData.databaseName)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSourceSystemName('')
            setDataSources([])
            setDimensions([])
            setSelectedDimension('')
            setFilesWithinZip([])
            setSelectedFileWithinZip('')
        }

        // hydrate from saved data like the other persisted fields; without this it resets to false on
        // mount and every other control's onChange writes that stale false back over the saved value
        setExistingMembers(props.taskData.importFromExistingMembers === true)

        if (props.jobFiles && props.jobFiles.length > 0) {
            setJobFiles(props.jobFiles)
            setSelectedJobFileId(props.taskData.selectedZipFileId)
            setSelectedJobFile(props.taskData.selectedZipFile)
            zipFileSelectedWithFiles(props.taskData.selectedZipFileId, props.jobFiles)
            setSelectedFileWithinZip(props.taskData.selectedFileWithinZip)
            fileWithinZipSelectedWithFiles(props.taskData.selectedFileWithinZip, props.jobFiles, props.taskData.selectedZipFile, props.taskData.selectedFileWithinZip).then(function() {
                setSelectedSourceColumn(props.taskData.selectedSourceColumn)
                setSelectedTargetColumn(props.taskData.selectedTargetColumn)
            })
        }
    }, [])

    useEffect(() => {
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setIsLoadingRequest(true)

            let getDataSources = props.getDataSources(props.taskData.databaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setDataSources(json)
                setDataSourceSystemName(props.taskData.dataSourceSystemName)
                setDimensions([])
                
                let getDimensions = props.getDimensions(props.taskData.databaseId, props.taskData.dataSourceSystemName)
                getDimensions.then((resp) => { 
                    if (resp.status !== 200) {
                        throw new Error(resp)
                    } else {
                        return resp.json()
                    }
                }).then((json) => {
                    setIsLoadingRequest(false)

                    let processedResponse = []
                    let processedSegments = []
                    for (let x = 0; x < json.length; x++) {
                        if (json[x]["typeOfDimension"] !== -1) {
                            processedResponse.push(json[x])
                        }
                        for (let y = 0; y < json[x]["segments"].length; y++) {
                            processedSegments.push({ "dimension": json[x]["systemName"], "alias": json[x]["segments"][y]["alias"] })
                        }
                    }

                    setDimensions(processedResponse)
                    setDimensionSegmentation(processedSegments)
                    setSelectedDimension(props.taskData.selectedDimensionSystemName)
                    setSelectedSegments(props.taskData.sourceFiles)
                }).catch((ex) => {
                    console.error(ex)
                    setDataSources([])
                    setDimensions([])
                    setSelectedDimension('')
                    setIsLoadingRequest(false)
                })
            }).catch((ex) => {
                console.error(ex)
                setDataSourceSystemName('')
                setDataSources([])
                setDatabaseName('')
                setDimensions([])
                setDimensionSegmentation([])
                setDatabaseName('')
                setSelectedDimension('')
                setIsLoadingRequest(false)
                setSearchTerm('')
            })

            setDatabaseName(props.taskData.databaseName)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSourceSystemName('')
            setDataSources([])
            setDimensions([])
            setSelectedDimension('')
        }

        if (props.jobFiles && props.jobFiles.length > 0) {
            fileWithinZipSelectedWithFiles(props.taskData.selectedFileWithinZip, props.jobFiles, props.taskData.selectedZipFile, props.taskData.selectedFileWithinZip).then(function() {
                setSelectedSourceColumn(props.taskData.selectedSourceColumn)
                setSelectedTargetColumn(props.taskData.selectedTargetColumn)
            })
        }
    }, [
        props.taskData.databaseId,
        props.taskData.databaseName,
        props.taskData.dataSourceSystemName,
        props.taskData.dataSourceName,
        props.taskData.membersToRemove,
        props.taskData.selectedDimensionSystemName,
        props.taskData.selectedZipFileId,
        props.taskData.selectedZipFile,
        props.taskData.selectedFileWithinZip,
        props.taskData.selectedSourceColumn,
        props.taskData.selectedTargetColumn,
        props.taskData.importFromExistingMembers,
        props.taskData.sourceFiles
    ])

    function handleDatabaseChange(event) {
        event.preventDefault()
        setDatabaseId(event.target.value)
        setIsLoadingRequest(true)

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            sqLDbList.forEach(db => {
                if (db.id === event.target.value) {
                    setDatabaseName(db.dBname)
                    fireOnSaveEvent(event.target.value, db.dBname, "", "", [], "", selectedJobFileId, selectedJobFile, selectedFileWithinZip, selectedSourceColumn, selectedTargetColumn, existingMembers, selectedSegments)
                }
            })
            setDataSources(json)
            setIsLoadingRequest(false)
        }).catch((ex) => {
            console.error(ex)
            setIsLoadingRequest(false)
            setDataSourceSystemName('')
            setDatabaseName('')
        })
    }

    function handleDataSourceChange(event) {
        event.preventDefault()
        setDataSourceSystemName(event.target.value)
        setIsLoadingRequest(true)

        dataSources.forEach((ds) => {
            if (ds.key === event.target.value) {
                fireOnSaveEvent(databaseId, databaseName, event.target.value, "", [], "", selectedJobFileId, selectedJobFile, selectedFileWithinZip, selectedSourceColumn, selectedTargetColumn, existingMembers, selectedSegments)
            }
        })

        let getDimensions = props.getDimensions(databaseId, event.target.value)
        getDimensions.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setIsLoadingRequest(false)
            
            let processedResponse = []
            let processedSegments = []
            for (let x = 0; x < json.length; x++) {
                if (json[x]["typeOfDimension"] !== -1) {
                    processedResponse.push(json[x])
                }
                for (let y = 0; y < json[x]["segments"].length; y++) {
                    processedSegments.push({ "dimension": json[x]["systemName"], "alias": json[x]["segments"][y]["alias"] })
                }
            }

            setDimensions(processedResponse)
            setDimensionSegmentation(processedSegments)
        }).catch((ex) => {
            console.error(ex)
            setDataSources([])
            setDimensions([])
            setDimensionSegmentation([])
            setSelectedDimension('')
            setIsLoadingRequest(false)
        })
    }

    function handleDimensionChange(event) {
        event.preventDefault()
        setSelectedDimension(event.target.value)
        setIsLoadingRequest(false)
        fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, "", [], event.target.value, selectedJobFileId, selectedJobFile, selectedFileWithinZip, selectedSourceColumn, selectedTargetColumn, existingMembers, selectedSegments)
    }

    function handleZipFileChange(event) {
        event.preventDefault()
        zipFileSelected(event.target.value)
    }

    async function handleFileWithinZipChange(event) {
        event.preventDefault()
        fileWithinZipSelected(event.target.value)
        
        let lookup = null
        for (let x = 0; x < jobFiles.length; x++) {
            if (jobFiles[x]["name"] === event.target.value) {
                lookup = jobFiles[x]
            }
        }

        if (lookup === null) {
            for (let x = 0; x < jobFiles.length; x++) {
                if (jobFiles[x]["identifier"] === event.target.value) {
                    lookup = jobFiles[x]
                }
            }   
        }

        if (lookup) {
            setIsLoadingRequest(true)
            let readColumnsReq = await props.readColumnsFromZipEntry(lookup.name, lookup.url, lookup.containerName, lookup.blobName, event.target.value)
            let readColumnsResp = await readColumnsReq.json()
            setColumnsReadFromFile(readColumnsResp)
            fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, "", [], selectedDimension, selectedJobFile, event.target.value, "", "", "", existingMembers, selectedSegments)
        } else {
            setColumnsReadFromFile([])
            setSelectedSegments([])
        }

        setIsLoadingRequest(false)
    }

    function zipFileSelected(zipFileName) {
        setSelectedJobFileId(zipFileName)
        setSelectedJobFile('')

        let lookup = null
        for (let x = 0; x < jobFiles.length; x++) {
            if (jobFiles[x]["identifier"] === zipFileName) {
                lookup = jobFiles[x]
            }
        }

        if (lookup) {
            setIsLoadingRequest(true)
            setSelectedJobFile(lookup["name"])
            setFilesWithinZip(lookup["zipIndividualFiles"])
            setIsLoadingRequest(false)
            fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, "", [], selectedDimension, zipFileName, lookup["name"], "", "", "", existingMembers, selectedSegments)
        } else {
            setSelectedJobFileId('')
            setSelectedJobFile('')
            setFilesWithinZip([])
            setSelectedFileWithinZip('')
        }
    }

    function zipFileSelectedWithFiles(zipFileName, files) {
        setSelectedJobFileId(zipFileName)
        setSelectedJobFile('')

        let lookup = null
        for (let x = 0; x < files.length; x++) {
            if (files[x]["identifier"] === zipFileName) {
                lookup = files[x]
            }
        }

        if (lookup) {
            setIsLoadingRequest(true)
            setSelectedJobFile(lookup["name"])
            setFilesWithinZip(lookup["zipIndividualFiles"])
            setIsLoadingRequest(false)
        } else {
            setSelectedJobFileId('')
            setSelectedJobFile('')
            setFilesWithinZip([])
            setSelectedFileWithinZip('')
        }
    }

    async function fileWithinZipSelected(fileWithinZipName) {
        setSelectedFileWithinZip(fileWithinZipName)

        let lookup = null
        for (let x = 0; x < jobFiles.length; x++) {
            if (jobFiles[x]["name"] === selectedJobFile) {
                lookup = jobFiles[x]
            }
        }

        if (lookup) {
            setIsLoadingRequest(true)
            let readColumnsReq = await props.readColumnsFromZipEntry(lookup.name, lookup.url, lookup.containerName, lookup.blobName, fileWithinZipName)
            let readColumnsResp = await readColumnsReq.json()
            setColumnsReadFromFile(readColumnsResp)
            fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, "", [], selectedDimension, selectedJobFileId, selectedJobFile, fileWithinZipName, "", "", existingMembers, selectedSegments)
        }

        setIsLoadingRequest(false)
    }

    async function fileWithinZipSelectedWithFiles(fileWithinZipName, files, selectedFile, nonZippedFile) {
        setSelectedFileWithinZip(fileWithinZipName)

        let lookup = null
        for (let x = 0; x < files.length; x++) {
            if (files[x]["name"] === selectedFile) {
                lookup = files[x]
            }
        }

        if (lookup === null) {
            for (let x = 0; x < files.length; x++) {
                if (files[x]["identifier"] === nonZippedFile) {
                    lookup = files[x]
                    setSelectedFileWithinZip(nonZippedFile)
                }
                if (files[x]["identifier"] === selectedFile) {
                    lookup = files[x]
                    setSelectedFileWithinZip(selectedFile)   
                }
            }
        }

        if (lookup) {
            setIsLoadingRequest(true)
            let readColumnsReq = await props.readColumnsFromZipEntry(lookup.name, lookup.url, lookup.containerName, lookup.blobName, fileWithinZipName)
            let readColumnsResp = await readColumnsReq.json()
            setColumnsReadFromFile(readColumnsResp)
        }

        setIsLoadingRequest(false)
    }

    /**
     * fireOnSaveEvent
     * * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dbName - Selected name of the database
     * @param {string} dsSystemName - Data source system name from the selected database
     * @param {string} dsName - Data source name
     * @param {string} dimSystemName - Selected dimension system name
     * @param {string} zipFileId - Selected zip file unique ID
     * @param {string} zipFileName - Selected zip file for the current job
     * @param {string} fileWithinZip - Desktop database within zip file
     * @param {string} sourceColumn - Source column found within the selected file
     * @param {string} targetColumn - Target column found within the selected file
     * @param {boolean} onlyExistingMembers - Only import segments for existing dimension members
     * @param {string[]} selectedSegments - All segments we want to use
     */
    function fireOnSaveEvent(dbId, dbName, dsSystemName, dsName, toRemove, dimSystemName, zipFileId, zipFileName, fileWithinZip, sourceColumn, targetColumn, onlyExistingMembers, selectedSegments) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["databaseName"] = dbName
            copied["dataSourceSystemName"] = dsSystemName
            copied["dataSourceName"] = dsName
            copied["membersToRemove"] = toRemove
            copied["selectedDimensionSystemName"] = dimSystemName
            copied["selectedZipFileId"] = zipFileId
            copied["selectedZipFile"] = zipFileName
            copied["selectedFileWithinZip"] = fileWithinZip
            copied["selectedSourceColumn"] = sourceColumn
            copied["selectedTargetColumn"] = targetColumn
            copied["sourceFiles"] = selectedSegments
            copied["importFromExistingMembers"] = onlyExistingMembers
            props.onSave(copied)
        }
    }

    /**
     * Reads the state variables to determine if we need to render the excel drop down
     */
    function renderMultiSegmentsOptions() {
        return (<FormControl className="field" fullWidth>
                <Autocomplete
                    multiple
                    id="excel-sheets-standard"
                    options={columnsReadFromFile}
                    getOptionLabel={(option) => option}
                    value={selectedSegments}
                    disabled={isLoadingRequest}
                    isOptionEqualToValue={(option, value) => option === value}
                    onChange={(event, newValue) => {
                        setSelectedSegments([ ...newValue ])
                        fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, "", [], selectedDimension, selectedJobFileId, selectedJobFile, selectedFileWithinZip, selectedSourceColumn, selectedTargetColumn, existingMembers, newValue)
                      }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="standard"
                            label="Segments"
                            placeholder="Segments"
                        />
                    )} />
            </FormControl>)
    }

    return <Paper elevation={3} className="dbFunctionsPaper">
        <h3>Import Segmentation</h3>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-databse-label">Select Database</InputLabel>
            <Select
                labelId="select-databse-label"
                id="select-databse"
                label="Select Database"
                onChange={handleDatabaseChange}
                defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                value={databaseId}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={-1}>Select Database</MenuItem>
                    { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-data-source-label">Select Data Source</InputLabel>
            <Select
                labelId="select-data-source-label"
                id="select-data-source"
                label="Select Data Source"
                onChange={handleDataSourceChange}
                value={dataSourceSystemName}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Data Source</MenuItem>
                    { dataSources.map((x) => x && <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>) }
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-dimension-label">Select Dimension</InputLabel>
            <Select
                labelId="select-dimension-label"
                id="select-dimension"
                label="Select Dimension"
                onChange={handleDimensionChange}
                value={selectedDimension}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Dimension</MenuItem>
                    { dimensions.map((x) => x && <MenuItem key={x.systemName} value={x.systemName}>{x.alias}</MenuItem>) }
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-zip-file-label">Select Zip File</InputLabel>
            <Select
                labelId="select-zip-file-label"
                id="select-zip-file"
                label="Select Zip File"
                onChange={handleZipFileChange}
                value={selectedJobFileId}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Zip File</MenuItem>
                    { jobFiles.map((x) => x && x.name.toLowerCase().includes(".zip") && <MenuItem key={x.identifier} value={x.identifier}>{x.name}</MenuItem>) }
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-file-within-zip-label">Select File Within Zip</InputLabel>
            <Select
                labelId="select-file-within-zip-label"
                id="select-file-within-zip"
                label="Select File Within Zip"
                onChange={handleFileWithinZipChange}
                value={selectedFileWithinZip}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select File Within Zip File</MenuItem>
                    { filesWithinZip.map((x) => x && <MenuItem key={x} value={x}>[{selectedJobFile}]{x}</MenuItem>) }
                    { jobFiles.map((x) => x && !x.name.toLowerCase().includes(".zip") && <MenuItem key={x.identifier} value={x.identifier}>{x.name}</MenuItem>) }
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-source-column-label">Target segmentation identifier</InputLabel>
            <Select
                labelId="select-source-column-label"
                id="select-source-column"
                label="Target segmentation identifier"
                onChange={(e) => {
                    e.preventDefault()
                    setSelectedSourceColumn(e.target.value)
                    fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, "", [], selectedDimension, selectedJobFileId, selectedJobFile, selectedFileWithinZip, e.target.value, selectedTargetColumn, existingMembers, selectedSegments)
                }}
                value={selectedSourceColumn}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={'&lt;Dimension member name&gt;'}>&lt;Dimension member name&gt;</MenuItem>
                    { dimensionSegmentation.map((x) => x && x.dimension === selectedDimension && <MenuItem key={x.alias} value={x.alias}>{x.alias}</MenuItem>) }
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-target-column-label">Source segmentation identifier</InputLabel>
            <Select
                labelId="select-target-column-label"
                id="select-target-column"
                label="Source segmentation identifie"
                onChange={(e) => {
                    e.preventDefault()
                    setSelectedTargetColumn(e.target.value)
                    fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, "", [], selectedDimension, selectedJobFileId, selectedJobFile, selectedFileWithinZip, selectedSourceColumn, e.target.value, existingMembers, selectedSegments)
                }}
                value={selectedTargetColumn}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Target Column</MenuItem>
                    { columnsReadFromFile.map((x) => x && <MenuItem key={x} value={x}>{x}</MenuItem>) }
            </Select>
        </FormControl>
        {renderMultiSegmentsOptions()}
        <FormControl className="field" fullWidth>
            <FormControlLabel
                label="Only import segments for existing dimension members"
                control={
                    <Checkbox
                        checked={existingMembers}
                        onChange={(e) => {
                            e.preventDefault()
                            setExistingMembers(e.target.checked)
                            fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, "", [], selectedDimension, selectedJobFileId, selectedJobFile, selectedFileWithinZip, selectedSourceColumn, selectedTargetColumn, e.target.checked, selectedSegments)
                        }}/>}>
                {"Only import segments for existing dimension members"}
            </FormControlLabel>
        </FormControl>
    </Paper>
}

export default ImportSegmentation